import { isAnyOf, Middleware as MiddlewareType, isFulfilled, isRejected } from "@reduxjs/toolkit";

import { addPosCategory, bulkDeleteCategoryData, deleteCategoryData, deleteCategoryProduct, getAllPosCategoryData, getMappedCategoryProducts, updatePosCategory } from "./slices/categorySlice";
import { addCartProducts, deleteCart, deleteCartProduct, getAllCategoriesForSellscreen, getCartProducts, getCategoryProductsForSellScreen, updateCartProducts } from "./slices/sellScreenSlice";
import { getPreference, updatePreference } from "./slices/preferenceSettingSlice";

import { ZenToast } from "zen-core-elements";
import { AppDispatch, RootState, store } from "./store";
import { config } from "../shared/environment";
import { createPosBrand, deleteBrandProducts, getAllBrands, getAllProductsBasedOnBrands, onePosBrand, updatePosBrand } from "./slices/brandSlice";
import { brandDataProps } from "../components/brand/brandModule";
import { DeviceEventEmitter } from "react-native";
import { addProductCatalog, bulkDeleteProductRedux, deleteProductRedux, getAllPosProductListRedux, updateProductCatalog, updateProductDetails } from "./slices/productSlice";
import { GetAllPosProductPayloadProps } from "../components/products/productList/productModule";
import { addNewStaff, changeStatus, deleteStaff, getAllStaffList, GetAllStaffListPayloadProps, STAFF_LIST_LIMIT, updateStaffDetails } from "./slices/staffSlice";


import { addPosDiscount, bulkDeleteDiscountData, getAllPosDiscountList, singleDeleteData, updateDiscountListStatus, updatePosDiscount } from "./slices/manualDiscountSlice";
import { bulkDeleteDiscount, createAutomatic, getAllPosDiscount, updatedAutomatic, updateDiscountStatus } from "./slices/automaticDiscountSlice";
import { changeEmail, getCurrentUser, getUserDetails, updateUserNotificationDetails, uploadLogoUrl } from "./slices/commonSlice";
import { buyXgetYBulkDeleteDiscount, buyXgetYUpdateDiscountStatus, getBuyXgetYDiscounts, saveBuyXgetY, updateBuyXgetY } from "./slices/buyXgetYDiscountSlice";
import { addPayXDiscount, bulkDeletePayXgetFreeDiscount, getOnePayxDiscount, getPayXGetFreePosDiscount, singlePayXGetFreeDelete, updatePayXDiscount, updatePayXGetFreeDiscountStatus } from "./slices/payXGetFreeSlice";
import { createRole, deletePosRole, getAllRoles, updateRole } from "./slices/rolesSlice";
import { getAllPosCustomerGroupRedux, updateCustomerGroupRedux } from "./slices/customerGroupSlice";
import { addNotes, getSingleOrderDetails, updateDiscount, updateOrderStatus, updateProductOptionVariants } from "./slices/orderDetailSlice";
import { adjustLoyalty, deleteCustomer, getAllCustomerList, getOneCustomerDetails, sendCustomerEmail, updateCustomerStatus } from "./slices/customerSlice";
import { getCustomerHistory } from "./slices/viewCustomerDetails.slice";
import { getAllReceiptSettings, updateReceiptSettings } from "./slices/receiptSettingSlice";
import { addPosLocation, deleteLocationData, editPosLocation, getAllLocationList } from "./slices/locationSlice";
import { createTax, getAllPosManualTax, updateorDeleteTax, updateTax } from "./slices/taxSlice";
import { getAllOrdersList, restoreOrder, updateOrderDetails } from "./slices/orderSlice";
import { placeOrderApi } from "./slices/newSellscreenPaymentSlice";
import { addCustomer, invalidateDiscountCache, refreshCartDiscounts, retriveSale } from "./slices/newSellscreenSlice";

const Middleware: MiddlewareType = ({ dispatch, getState }: { dispatch: AppDispatch, getState: () => RootState }) => (next) => (action) => {

    const userDetails = getState()?.common?.currentUser?.value;

    if (isFulfilled(updatePosCategory)(action) ||
        isFulfilled(deleteCategoryData)(action) ||
        isFulfilled(bulkDeleteCategoryData)(action) ||
        isFulfilled(addPosCategory)(action)
    ) {
        const { storeId } = action.meta.arg;
        dispatch(getAllCategoriesForSellscreen({ storeId }));
    }
    if (isFulfilled(updatePreference)(action)) {
        ZenToast({
            type: "success",
            message: "Preference updated succesfully"
        })
        const { storeId } = action.meta.arg;
        dispatch(getPreference({ storeId: storeId }))
    }
    if (isRejected(updatePreference)(action)) {
        ZenToast({
            type: "error",
            message: "Failed to update a preference data, Please try again after some time!"
        })
        const { storeId } = action.meta.arg;
        dispatch(getPreference({ storeId: storeId }))
    }




    //Brand Page

    function callGetBrand(storeId: number) {
        DeviceEventEmitter.emit('BRAND_UPDATED');
        const data: brandDataProps = {
            offset: 0,
            limit: 20,
            searchText: '',
            sortOrder: JSON.stringify({ "field": "brand_name", "order": "ASC" }),
            filterData: null
        };
        dispatch(getAllBrands({ storeId: storeId, data: data }))
    }
    if (isFulfilled(createPosBrand)(action)) {
        const { storeId } = action.meta.arg;
        callGetBrand(storeId)
    }

    if (isFulfilled(updatePosBrand)(action) || isFulfilled(deleteBrandProducts)(action)) {
        const { storeId, id } = action.meta.arg;
        const data = {
            offset: 0,
            limit: 20,
            value: '',
            sortOrder: JSON.stringify([['name', 'asc']]),
            brandId: id
        };
        dispatch(getAllProductsBasedOnBrands({ data, storeId: config?.storeId }))
        dispatch(onePosBrand({ id, storeId }))
        callGetBrand(storeId)
    }




    //Manual Discount Page
    function callToGetManualDiscount(storeId: number) {
        DeviceEventEmitter.emit('MANUAL_DISCOUNT_UPDATED');
        const data = { offset: 0, limit: 10, filterData: null, searchText: "", type: "Manual" }
        dispatch(getAllPosDiscountList({ storeId: storeId, data: data }))
    }
    if (isFulfilled(addPosDiscount)(action) || isFulfilled(updatePosDiscount)(action) || isFulfilled(singleDeleteData)(action) || isFulfilled(bulkDeleteDiscountData)(action) || isFulfilled(updateDiscountListStatus)(action)) {
        const { storeId } = action.meta.arg;
        callToGetManualDiscount(storeId)
    }


    //Automatic Discount Page
    function callToGetAutomaticDiscount(storeId: number) {
        DeviceEventEmitter.emit('AUTOMATIC_DISCOUNT_UPDATED');
        const data = { offset: 0, limit: 10, filterData: null, searchText: "", type: "Automatic" }
        dispatch(getAllPosDiscount({ storeId: storeId, data: data }))
    }
    if (isFulfilled(createAutomatic)(action) || isFulfilled(updatedAutomatic)(action) || isFulfilled(updateDiscountStatus)(action) || isFulfilled(bulkDeleteDiscount)(action)) {
        const { storeId } = action.meta.arg;
        callToGetAutomaticDiscount(storeId)
    }

    //Categories
    function callToGetCategories() {
        DeviceEventEmitter.emit('CATEGORIES_UPDATED');
        const data = { offset: 0, limit: 10, searchText: '', filterData: null, sortOrder: JSON.stringify({ field: "category_name", order: "ASC" }) }
        dispatch(getAllPosCategoryData({ storeId: config.storeId, data: data }))
    }
    if (isFulfilled(addPosCategory)(action) || isFulfilled(updatePosCategory)(action) || isFulfilled(deleteCategoryData)(action) || isFulfilled(bulkDeleteCategoryData)(action) || isFulfilled(deleteCategoryProduct)(action)) {
        callToGetCategories()
    }

    // Products in add/edit categories
    if (isFulfilled(deleteCategoryProduct)(action)) {
        DeviceEventEmitter.emit('PRODUCTS_UPDATED');
        const categoryId = action.meta.arg.categoryId
        const data = {
            offset: 0,
            limit: 10,
            searchText: '',
            sortOrder: JSON.stringify({ field: 'name', order: 'asc' }),
            categoryId: categoryId,
            isMapped: true
        }
        dispatch(getMappedCategoryProducts({ storeId: config.storeId, data, isAllProduct: true }))


    }

    // Orders 
    if (isFulfilled(updateOrderStatus)(action) || isFulfilled(restoreOrder)(action) || isFulfilled(addNotes)(action) || isFulfilled(updateProductOptionVariants)(action) || isFulfilled(updateDiscount)(action)) {
        const { isPos } = action.meta.arg;
        DeviceEventEmitter.emit("ORDERS_UPDATED", { isPos: isPos ?? false })
    }





    //view customer details
    if (isFulfilled(adjustLoyalty)(action)) {
        const { storeId, customerId } = action.meta.arg
        dispatch(getCustomerHistory({ storeId: storeId, customerId: customerId }))
        dispatch(getOneCustomerDetails({ storeId: storeId, customerId: customerId }))
    }




    //Product List Page
    function callGetProductList(storeId: number) {
        DeviceEventEmitter.emit('PRODUCT_UPDATED');
        const data: GetAllPosProductPayloadProps["data"] = {
            offset: 0,
            limit: 10,
            searchText: '',
            sortOrder: JSON.stringify({ "field": "name", "order": "ASC" }),
            categoryId: null,
            storeId: config.storeId
        };
        const state = getState()

        const { id } = state.common.currentLocation

        dispatch(getAllPosProductListRedux({ storeId: config.storeId, data: data }))
        let payload = {
            limit: 10,
            offset: 0,
            categoryId: "",
            searchText: "",
            locationId: id
        }
        dispatch(getCategoryProductsForSellScreen({ storeId: config?.storeId, payload }))
    }
    if (isFulfilled(addProductCatalog)(action) || isFulfilled(updateProductCatalog)(action) || isFulfilled(deleteProductRedux)(action) || isFulfilled(bulkDeleteProductRedux)(action) || isFulfilled(updateProductDetails)(action)) {
        const { storeId } = action.meta.arg;
        callGetProductList(storeId)
    }

    //Staff List Page

    function callGetStaffList(storeId: number) {
        DeviceEventEmitter.emit('STAFF_UPDATED');
        // Same params as the staff list screen, which paginates locally over the full list
        const data: GetAllStaffListPayloadProps["data"] = {
            offset: 0,
            limit: STAFF_LIST_LIMIT,
            searchText: '',
            filterData: null
        };
        dispatch(getAllStaffList({ storeId: storeId, data: data, roleId: userDetails?.clientId || "", isActive: false }))
        dispatch(getAllStaffList({ storeId: storeId, data: data, roleId: userDetails?.clientId || "", isActive: true }))
    }
    if (isFulfilled(addNewStaff)(action) || isFulfilled(updateStaffDetails)(action) || isFulfilled(changeStatus)(action) || isFulfilled(deleteStaff)(action)) {
        const { storeId } = action.meta.arg;
        callGetStaffList(storeId)
    }

    //Tax  Page

    function callGetTaxList(storeId: number) {
        DeviceEventEmitter.emit('TAX_UPDATED');
        const data = {
            offset: 0,
            limit: 10,
            globalSearch: '',
            filterData: null
        };
        dispatch(getAllPosManualTax({ storeId: storeId, data: data }))
    }
    if (isFulfilled(createTax)(action) || isFulfilled(updateTax)(action) || isFulfilled(updateorDeleteTax)(action)) {
        const { storeId } = action.meta.arg;
        callGetTaxList(storeId)
    }

    //Receipt settings Page

    function callGetReceiptSettings(storeId: number, receiptType: "GIFT" | "SALES") {
        const data: GetAllStaffListPayloadProps["data"] = {
            offset: 0,
            limit: 10,
            searchText: '',
            filterData: null
        };
        dispatch(getAllReceiptSettings({ storeId: storeId, receiptType }))
    }
    if (isFulfilled(updateReceiptSettings)(action)) {
        const { storeId, data: { receiptType } } = action.meta.arg;
        callGetReceiptSettings(storeId, receiptType)
    }

    //Role List Page

    if (isFulfilled(createRole)(action) || isFulfilled(updateRole)(action) || isFulfilled(deletePosRole)(action)) {
        const { storeId } = action.meta.arg;
        // DeviceEventEmitter.emit('ROLE_UPDATED');
        dispatch(getAllRoles({ storeId: storeId }))
    }

    // My Account Page

    if (isFulfilled(updateUserNotificationDetails)(action) || isFulfilled(changeEmail)(action) || isFulfilled(uploadLogoUrl)(action)) {
        const { storeId, userId } = action.meta.arg;
        dispatch(getUserDetails({ storeId: storeId, userId: userId }))
        dispatch(getCurrentUser())
    }

    // BuyXgetY Discount Page
    if (isFulfilled(buyXgetYBulkDeleteDiscount)(action) || isFulfilled(buyXgetYUpdateDiscountStatus)(action) || isFulfilled(updateBuyXgetY)(action) || isFulfilled(saveBuyXgetY)(action)) {
        const { storeId } = action.meta.arg;
        DeviceEventEmitter.emit('BUYXGETY_UPDATED');
        dispatch(getBuyXgetYDiscounts({ storeId: storeId, data: { offset: 0, limit: 10, searchText: '', filterData: null, type: 'BuyXGetY' } }))
    }

    // PayXgetFree Discount Page
    if (isFulfilled(bulkDeletePayXgetFreeDiscount)(action) || isFulfilled(updatePayXGetFreeDiscountStatus)(action) || isFulfilled(addPayXDiscount)(action) || isFulfilled(singlePayXGetFreeDelete)(action)) {
        const { storeId } = action.meta.arg;
        DeviceEventEmitter.emit('PAYXGETFREE_UPDATED');
        dispatch(getPayXGetFreePosDiscount({ storeId: storeId, data: { offset: 0, limit: 10, searchText: '', filterData: null, type: 'PayXGetFree' } }))
    }
    if (isFulfilled(updatePayXDiscount)(action)) {
        const { storeId, id } = action.meta.arg;
        DeviceEventEmitter.emit('PAYXGETFREE_UPDATED');
        dispatch(getOnePayxDiscount({ storeId: storeId, id: id }))
        dispatch(getPayXGetFreePosDiscount({ storeId: storeId, data: { offset: 0, limit: 10, searchText: '', filterData: null, type: 'PayXGetFree' } }))
    }

    // Location list Page
    if (isFulfilled(addPosLocation)(action) || isFulfilled(editPosLocation)(action) || isFulfilled(deleteLocationData)(action)) {
        const { storeId } = action.meta.arg;
        DeviceEventEmitter.emit('LOCATION_UPDATED');
        dispatch(getAllLocationList({ storeId: storeId, data: { offset: 0, limit: 10, searchText: '', filterData: null } }))
    }

    // Customer Group Page
    if (isFulfilled(updateCustomerGroupRedux)(action)) {
        const { storeId } = action.meta.arg
        dispatch(getAllPosCustomerGroupRedux({ storeId: storeId, data: { offset: 0, limit: 10, globalsearch: "", filterData: null } }))
    }

    // Customer Page
    if (isFulfilled(deleteCustomer)(action) || isFulfilled(sendCustomerEmail)(action) || isFulfilled(updateCustomerStatus)(action)) {
        const { storeId } = action.meta.arg
        dispatch(getAllCustomerList({ storeId: storeId, data: { offset: 0, limit: 10, searchText: "", filterData: "", isActive: true, sort: JSON.stringify([["name", "ASC"]]) } }))
        dispatch(getAllCustomerList({ storeId: storeId, data: { offset: 0, limit: 10, searchText: "", filterData: "", isActive: false, sort: JSON.stringify([["name", "ASC"]]) } }))
    }

    // Sell screen Page
    if (isFulfilled(placeOrderApi)(action) || isFulfilled(updateOrderDetails)(action)) {
        const { storeId } = action.meta.arg
        const currentState = getState();

        const state = getState()
        const { id } = state.common.currentLocation
        dispatch(getAllOrdersList({ storeId, data: { limit: 10, offset: 0 }, isPos: true }))
        let data = {
            limit: 10,
            offset: 0,
            categoryId: "",
            searchText: "",
            locationId: id
        }
        dispatch(getCategoryProductsForSellScreen({ storeId: config?.storeId, payload: data }))
    }

    //addEditCartProduct
    if (isFulfilled(addCartProducts)(action)
        || isFulfilled(deleteCartProduct)(action)
        || isFulfilled(deleteCart)(action)
        || isFulfilled(updateCartProducts)(action)) {
        const state = getState()
        const { value: currentUser } = state?.common.currentUser
        const { id, timeZone } = state.common.currentLocation
        const customer = state.sellScreen.selectedCustomer
        dispatch(getCartProducts({
            industryName: currentUser?.industry?.name!!,
            locationId: id,
            timeZone,
            customerId: customer?.id!!,
            storeId: config.storeId
        }))
    }

    const result = next(action);  // Dispatch the action

    // Sell screen discounts: refetch when the customer changes or a held order is resumed,
    // and after the server rejects an order (a discount may have hit its usage limit or expired)
    if (addCustomer.match(action) || retriveSale.match(action)) {
        const { cartProducts } = getState().NewSellscreenSlice
        Object.keys(cartProducts ?? {}).forEach((locationId) => {
            if (cartProducts[Number(locationId)]?.length) dispatch(refreshCartDiscounts({ locationId: Number(locationId) }))
        })
    }
    // A discount was added / edited / deleted / switched on or off: the sell screen's per-variant
    // discount cache is stale. Drop it, and refetch the lines already in a cart so totals update.
    if (isFulfilled(
        createAutomatic, updatedAutomatic, updateDiscountStatus, bulkDeleteDiscount,
        saveBuyXgetY, updateBuyXgetY, buyXgetYUpdateDiscountStatus, buyXgetYBulkDeleteDiscount,
        addPayXDiscount, updatePayXDiscount, updatePayXGetFreeDiscountStatus, singlePayXGetFreeDelete, bulkDeletePayXgetFreeDiscount
    )(action)) {
        dispatch(invalidateDiscountCache())
        const { cartProducts } = getState().NewSellscreenSlice
        Object.keys(cartProducts ?? {}).forEach((locationId) => {
            if (cartProducts[Number(locationId)]?.length) dispatch(refreshCartDiscounts({ locationId: Number(locationId) }))
        })
    }
    if (isRejected(placeOrderApi)(action) || (isFulfilled(placeOrderApi)(action) && !action.payload?.success)) {
        dispatch(refreshCartDiscounts({ locationId: getState().common.currentLocation.id }))
    }
    return result
};

export default Middleware